import {
  ADD_HEADLINE,
  REMOVE_HEADLINE,
  CHANGE_HEADLINE,
  ADD_DESCRIPTION,
  REMOVE_DESCRIPTION,
  CHANGE_DESCRIPTION,
  CHANGE_BUSINESSNAME,
  ADD_IMAGE,
  ADD_IMAGES,
  UPDATE_IMAGE_STATE,
  ADD_CROPPED_IMAGE,
  ADD_CROPPED_LOGO,
  REMOVE_CROPPED_IMAGE,
  REMOVE_CROPPED_LOGO,
  CREATE_PREVIEW_IMAGES,
  CHANGE_LOADING_STATE,
  CLEAR_IMAGES,
  CLEAR_PREVIEW_IMAGES,
  CLEAR_CROPPED_IMAGES,
  CLEAR_CROPPED_LOGOS
} from "./types.js";

/**
 * TODO: Add action file for each type
 */

// -------------------------------------- Headline --------------

export const addHeadline = () => ({
  type: ADD_HEADLINE
});

export const removeHeadline = index => ({
  type: REMOVE_HEADLINE,
  payload: index
});

export const changeHeadline = (index, value) => dispatch => {
  dispatch({
    type: CHANGE_HEADLINE,
    payload: {
      index,
      value
    }
  });
};

// -------------------------------------- Description --------------
export const addDescription = () => ({
  type: ADD_DESCRIPTION
});

export const removeDescription = index => ({
  type: REMOVE_DESCRIPTION,
  payload: index
});

export const changeDescription = (index, value) => ({
  type: CHANGE_DESCRIPTION,
  payload: {
    index,
    value
  }
});

// ---------------------------------------- Business name -------------

export const changeBusinessName = (index, value) => ({
  type: CHANGE_BUSINESSNAME,
  payload: {
    index,
    value
  }
});

// -------------------------------------- Image --------------

export const addImage = (url, uid, type) => ({
  type: ADD_IMAGE,
  payload: {
    url,
    uid,
    type
  }
});

export const addImages = (images, type) => ({
  type: ADD_IMAGES,
  payload: {
    images,
    type
  }
});

export const updateImageState = (uid, isCropped) => ({
  type: UPDATE_IMAGE_STATE,
  payload: {
    uid,
    isCropped
  }
});

export const addCroppedImage = (urls, uid) => ({
  type: ADD_CROPPED_IMAGE,
  payload: {
    urls,
    uid
  }
});

export const addCroppedLogo = (urls, uid) => ({
  type: ADD_CROPPED_LOGO,
  payload: {
    urls,
    uid
  }
});

export const removeCroppedImage = uid => ({
  type: REMOVE_CROPPED_IMAGE,
  payload: {
    uid
  }
});

export const removeCroppedLogo = uid => ({
  type: REMOVE_CROPPED_LOGO,
  payload: {
    uid
  }
});

export const clearImages = type => ({
  type: CLEAR_IMAGES,
  payload: {
    type
  }
});

export const clearCroppedImages = () => ({
  type: CLEAR_CROPPED_IMAGES
});

export const clearCroppedLogos = () => ({
  type: CLEAR_CROPPED_LOGOS
});
// --------------------------------------- CREATE_PREVIEW_IMAGES --------------

export const createPreviewImages = () => (dispatch, getState) => {
  const {
    headlines,
    descriptions,
    businessName,
    croppedImages,
    croppedLogos
  } = getState();
  dispatch({
    type: CREATE_PREVIEW_IMAGES,
    payload: {
      headlines,
      descriptions,
      businessName,
      croppedImages,
      croppedLogos
    }
  });
};

export const clearPreviewImages = () => ({
  type: CLEAR_PREVIEW_IMAGES
});
// ---------------------------------------- Upload Modal --------------------

export const showUploadModal = info => ({
  type: CHANGE_LOADING_STATE,
  payload: {
    info
  }
});
